import React, { PropsWithChildren, useContext } from 'react'
import { CardDesignCarousel } from '../../../components/CardDesignCarousel/CardDesignCarousel'
import { CardDesignItem } from '../../../components/CardDesignCarousel/CardDesignItem'
import { GlobalContext } from '../../../globals/context'
import { nonNull } from '../../../utils/nonNull'
import { truncate } from '../../../utils/truncate'
import { NewsFragment } from '@gql'
import { Button } from '../../../components/button/button'
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { StyledCardBody } from '../../../components/CardDesignCarousel/styledCardDesignCarousel'

export type NewsProps = NewsFragment

export const News: React.FC<PropsWithChildren<NewsProps>> = ({ entries }) => {
  if (!entries?.length ?? 0 > 0) {
    return null
  }

  const { fallback } = useContext(GlobalContext)

  if (fallback?.globalSet?.__typename !== 'siteSettings_GlobalSet') {
    return null
  }

  const { newsFallbackImage } = fallback?.globalSet

  return (
    <>
      <CardDesignCarousel title={'Latest News Articles'} columns={3} $overflow>
        {nonNull(entries).map((item, index) => {
          if (item.__typename === 'news_newsEntryType_Entry') {
            const useNewBanner = item.useNewBanner
            const banner = useNewBanner ? item.secondaryPageBanner : item.newsDetailBanner
            const url = banner?.[0]?.image?.[0]?.url || newsFallbackImage?.[0]?.url

            return (
              <CardDesignItem key={index} href={item.uri || '#'}>
                <CardDesignItem image src={url} alt={''} layout="fill" objectFit="cover" objectPosition="center" />
                <StyledCardBody>
                  <CardDesignItem date>{new Date(item.postDate).toLocaleString('en-AU', { year: 'numeric', month: 'short', day: 'numeric' })}</CardDesignItem>
                  <CardDesignItem title>{item?.title ? truncate(item.title, 75) : 'Untitled'}</CardDesignItem>
                  <Button className="card-cta" href={item.uri || '#'} icon={faAngleRight} text> Read more </Button>
                </StyledCardBody>


              </CardDesignItem>
            )
          }

          return null
        })}
      </CardDesignCarousel>
    </>
  )
}
